import { Component, OnInit } from '@angular/core';
import { RightSideDrawerService } from '../right-side-drawer.service';
import { EmployeeInformationService } from 'src/app/data-analysis-summary/employee-information/employee-information.service';
import { SessionService } from '../../session-service/session.service';
import { Employee } from 'src/app/data-analysis-summary/employee-information/employee-information.models';
import { BehaviorSubject } from 'rxjs';
import { ToastrService } from '@kpmg-tax/ui';

@Component({
  selector: 'ei-delete-multiple-employee',
  templateUrl: './ei-delete-multiple-employee.component.html',
  styleUrls: ['./ei-delete-multiple-employee.component.scss'],
})
export class EiDeleteMultipleEmployeeComponent implements OnInit {
  employees: Employee[] = [];
  targetFormSubmitted: boolean = false;
  expanded = new Map<number, boolean>();
  isSelected: boolean = true;
  deleteEmployeedata: any = [];
  isDisabled: boolean = false;

  constructor(
    public rightSideDrawerService: RightSideDrawerService,
    public sessionService: SessionService,
    private employeeInformationService: EmployeeInformationService,
    public toastrService: ToastrService,
  ) {
    /* this.employees = this.rightSideDrawerService.multipleRowAddData;
    console.log(this.employees);
    for (let i = 0; i < this.employees.length; i++) {
      this.expanded[i] = false;
    }
    this.deleteEmployeedata = this.employees.map(
      ({engagementId, employeeId}) => ({engagementId, employeeId}),
    );
    console.log(this.deleteEmployeedata);*/
  }

  public buildData(employees) {
    this.rightSideDrawerService.multipleRowAddData = employees;
  }
  ngOnInit() {
    this.employees = this.rightSideDrawerService.multipleRowAddData;
    console.log(this.employees);
    for (let i = 0; i < this.employees.length; i++) {
      this.expanded[i] = false;
    }
    this.deleteEmployeedata = this.employees.map(
      ({ engagementId, employeeId }) => ({ engagementId, employeeId }),
    );
  }

  deleteEmployees = () => {
    this.isDisabled = true;
    let deleteEmployeedata: { engagementId: number, employeeIds: number[] } = {
      engagementId: this.deleteEmployeedata[0]?.engagementId,
      employeeIds: this.deleteEmployeedata.map(x => x.employeeId)
    }

    this.sessionService.apiUrlPost('Employee/DeleteEmployees', deleteEmployeedata).subscribe(data => {
      // If request is successful, Refresh data table on page
      let localData: any = data;
      if (localData && localData.result && localData.success) {
        this.toastrService.setSuccessMessage(
          'Employee data deleted successfully.',
        );
        this.employeeInformationService.refreshTable();
        this.rightSideDrawerService.closeRightSideDrawer();
        console.log(
          'These employees were deleted successfully:',
          deleteEmployeedata,
        );
      } else {
        this.toastrService.setErrorMessage('Error from Back End API. Tried to delete bulk employees: ');
        this.employeeInformationService.refreshTable();
        this.rightSideDrawerService.closeRightSideDrawer();
      }

    });
  }
  toggleExpandRow(event: any, i) {
    if (this.expanded[i] === false) {
      this.expanded[i] = true;
    } else {
      this.expanded[i] = false;
    }
    console.log(event.target.value, i);
  }
  removeEmployee(employee: any, i) {
    console.log(employee);
    console.log(this.deleteEmployeedata);
    const found = this.deleteEmployeedata.some(
      el => el.employeeId === employee.employeeId,
    );
    console.log(found);
    if (!found) {
      //let emp=employee.filter(x=>x.)
      this.deleteEmployeedata.push({
        engagementId: employee.engagementId,
        employeeId: employee.employeeId,
      });
    } else {
      this.deleteEmployeedata.forEach((item, index) => {
        if (item.employeeId === employee.employeeId) {
          this.deleteEmployeedata.splice(index, 1);
        }
        //this.deleteEmployeedata.splice(i, 1);
      });
    }
    //delete this.deleteEmployeedata[i];
    //this.deleteEmployeedata=this.deleteEmployeedata.splice(i,1);
    console.log(this.deleteEmployeedata);
    this.rightSideDrawerService.setMandatoryField(true, 'Delete Multiple Employees');
  }
}
